import React, { useMemo } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { useTemuShop } from '@/temu-platform/context/TemuShopContext';
import '@/styles/ipe/workbench/PlatformProductManagePage.css';
import '@/styles/temu-platform/temu-product-ops.css';

/**
 * 产品管理内容壳：页头已去掉，二级菜单在侧栏，此处只承载主内容。
 */
export default function TemuProductOpsLayout() {
  const { activeShop } = useTemuShop();
  const shopLabel = useMemo(
    () => activeShop?.shopName || '未选择店铺',
    [activeShop],
  );

  return (
    <div className="temu-product-ops temu-product-ops--wide" data-testid="temu-product-ops">
      <div className="temu-product-ops__workspace">
        <div className="temu-product-ops__content temu-product-ops__content--flush">
          <Outlet context={{ shopLabel }} />
        </div>
      </div>
    </div>
  );
}

export function useProductOpsContext() {
  return useOutletContext() || {};
}
